import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgEllipseComponent } from './svgellipse.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgEllipseComponent],
  exports: [SvgEllipseComponent]
})
export class SvgEllipseModule { }
